<script setup lang="ts">
import { useErhlCustomerLoanAppProcess } from '@/helpers/useErhlCustomerLoanAppProcess';
import ProductSelectionStep from './ProductSelectionStep.vue';

const { send } = useErhlCustomerLoanAppProcess();

/** Starts (or resumes) the application at its first ready step */
const startApplication = () => {
  send('READY');
};
</script>

<template>
  <div class="mt-16 grid w-full place-items-center">
    <div
      class="flex min-h-[575px] w-full flex-col rounded border border-gray-100 bg-white p-8 shadow-lg sm:w-3/4 lg:w-2/3"
      data-test-id="erhl-customer-welcome"
    >
      <h1 class="w-full text-center text-2xl font-medium">Welcome to the Equity Release Home Loan Application</h1>
      <ProductSelectionStep class="w-full" @select="startApplication" />
    </div>
  </div>
</template>
